/** @jsx jsx */
import { jsx } from '@emotion/core';
import React, { useRef } from 'react';
import { Typography } from '@material-ui/core';
import { Field, FieldProps } from 'formik';
import useTranslate from 'hooks/useTranslate';
import { FormTextField, TextFieldPopover } from 'components/TextField';

import { phoneMask } from 'utils/masks';
import { useSelector } from 'react-redux';
import { selectLockedFields } from 'state/creditApplication';
import { TextFieldProps } from 'components/TextField/TextField';

type PropTypes = {
  showDisclosure?: boolean;
} & TextFieldProps;

const MobileField: React.FC<PropTypes> = ({
  showDisclosure = true,
  ...props
}) => {
  const t = useTranslate();
  const lockedFields = useSelector(selectLockedFields);
  const mobilePhoneRef = useRef<HTMLElement | null>(null);
  // const { showDisclosure = true } = props;

  return (
    <React.Fragment>
      <Field name="mobilePhone">
        {(fieldProps: FieldProps) => (
          <FormTextField
            id="creditAppMobilePhone"
            inputRef={mobilePhoneRef}
            disabled={lockedFields.mobilePhone}
            autoComplete="tel"
            type="tel"
            fieldProps={fieldProps}
            label={t('formLabel.mobilePhone')}
            mask={phoneMask}
            {...props}
          />
        )}
      </Field>
      {showDisclosure && (
        <TextFieldPopover
          id="creditAppMobilePhonePopover"
          textFieldRef={mobilePhoneRef}
        >
          <Typography variant="body2">
            {t('creditApplication.phoneAgreement')}
          </Typography>
        </TextFieldPopover>
      )}
    </React.Fragment>
  );
};

export default MobileField;
